// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env } from './.env';
import { Environment, ReleaseStage } from '@env/environment.model';

export const environment: Environment = {
  bugsnagApiKey: '71166e154e36b92489f119ce225a5573',
  defaultLanguage: 'en-US',
  googleAnalyticsId: 'G-8MYL5F18WD',
  features: {
    mockBackEnd: false,
  },
  oldProgramUrl: `https://program.potentialife.com`,
  production: true,
  releaseStage: ReleaseStage.prod,
  serverUrl: 'https://api.potentialife.com/v1',
  supportedLanguages: ['en-US', 'fr-FR'],
  viaSurveyApiKey: 'F9C66D59-4551-4564-AFD5-31384735A4B8',
  version: env['npm_package_version'],
};
